var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSafety(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1404",
    "data-name": "Group 1404",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 51.064,
    height: 47.231,
    viewBox: "0 0 51.064 47.231",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1062",
    d: "M0-682.665H51.064v47.231H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1058"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1060",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1066",
    transform: "translate(4.588 1.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1068",
    d: "M-518.11-71.859c0,33.209-20.944,38.873-20.944,38.873S-560-38.65-560-71.859c10.472,0,20.944-5.341,20.944-5.341S-528.582-71.859-518.11-71.859Z",
    transform: "translate(559.999 77.2)",
    fill: "rgba(0,0,0,0)",
    stroke: "#1b9c5d",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1070",
    transform: "translate(13.564 9.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1072",
    d: "M-296.063-150.171c0,6.114-5.358,11.07-11.968,11.07S-320-144.057-320-150.171s5.358-11.162,11.968-11.162S-296.063-156.285-296.063-150.171Z",
    transform: "translate(319.999 161.333)",
    fill: "rgba(0,0,0,0)",
    stroke: "#1b9c5d",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1074",
    transform: "translate(19.548 17.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1076",
    d: "M0-38.474l4.488,4.151,7.48-7.011",
    transform: "translate(0 41.333)",
    fill: "rgba(0,0,0,0)",
    stroke: "#1b9c5d",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafety);
export default __webpack_public_path__ + "static/media/safety.d56420362d1e6f3b7f7ec4cc70389833.svg";
export { ForwardRef as ReactComponent };